import React, { useState } from 'react'
import { TextField, Toolbar, Typography, Button } from '@mui/material';
import AddUpdateSubjectDialog from 'app/components/Dialog/AddUpdateSubjectDialog';

function SubjectDataTableToolbar({ pageTitle, data2, setData, afterUpdateFunc, addAfterTable }) {

    const [searchText, setSearchText] = useState("");
    const [addSubjectDialogStatus, setAddSubjectDialogStatus] = useState(false);

    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const filterData = data2.filter(
                (item) =>
                    item.name.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.id === Number(text)
            );
//
            setSearchText(text);
            setData(filterData);
        } else {
            setSearchText(text);
            setData(data2);
        }
    };


    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'space-between', background: '#e1e1e1' }}>
            <div className="title">
                <Typography variant="title">{pageTitle}</Typography>
            </div>

            <div>
                <Button variant="contained" sx={{ marginTop: '14px', marginRight: '10px' }} size="large" onClick={() => setAddSubjectDialogStatus(true)}>Konu Ekle</Button>

                <TextField
                    id="searchText1xe"
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                    margin="dense"
                    label={"Arama Yap"}
                    className="mr-4"
                    // autoFocus
                    style={{ width: "400px", background: 'white' }}
                    placeholder={'Bilgi'}
                />
            </div>
            <AddUpdateSubjectDialog open={addSubjectDialogStatus} onClose={() => setAddSubjectDialogStatus(false)} afterUpdateFunc={afterUpdateFunc} addAfterTable={addAfterTable} />
        </Toolbar>
    );
};

export default SubjectDataTableToolbar